<template>
  <div>
    <router-link to="/userProjects">
      <a
        href="#"
        class="relative inline-flex items-center my-2 py-2 text-purple text-sm leading-5 font-medium font-bebas text-3xl
         transition ease-in-out duration-150 border-b-2 border-purple

"
      >
        Back to Show &amp; Tell
      </a>
    </router-link>
    <div
      class="py-16  mt-2 px-4 sm:px-6 lg:px-8 bg-vlight-paper overflow-hidden rounded shadow"
      v-if="project"
    >
      <div class="max-w-max-content lg:max-w-7xl mx-auto">
        <div class="relative z-10 mb-8 md:mb-2 md:px-6">
          <div class="text-base max-w-prose lg:max-w-none">
            <p
              class="text-base leading-6 text-green  tracking-wide uppercase font-bebas text-2xl tracking-wider"
            >
              {{ project.yourName }}
            </p>
            <h1
              class="mt-4 mb-8  font-bebas text-5xl leading-10 font-extrabold tracking-wider text-gray-900 "
            >
              {{ project.projectTitle }}
            </h1>
          </div>
        </div>
        <div class="relative">
          <div class="relative bg-vlight-paper md:p-6">
            <div class="lg:grid lg:grid-cols-2 lg:gap-6 mb-8">
              <!--              First column -->
              <div class="mb-6 lg:max-w-none lg:mb-0">
                <iframe
                  v-if="hasVideo"
                  width="500px"
                  height="280px"
                  class="w-full"
                  :src="youtubeUrl"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                >
                </iframe>
                <simple-gallery
                  :images="project.projectPhotos"
                  v-if="!hasVideo"
                ></simple-gallery>

                <vue-flux
                  :options="vfOptions"
                  :images="project.projectPhotos"
                  :transitions="vfTransitions"
                  ref="slider"
                  v-if="false"
                >
                  <template v-slot:preloader>
                    <flux-preloader />
                  </template>
                  <template v-slot:controls>
                    <flux-controls />
                  </template>

                  <template v-slot:pagination>
                    <flux-pagination />
                  </template>

                  <template v-slot:index>
                    <flux-index />
                  </template>
                </vue-flux>
                <div class="mt-2">
                  <reaction-bar :document-id="project._id"></reaction-bar>
                </div>
                <hr class="mt-2" />
                <h1
                  v-if="isAdmin && !project.allowMarketing"
                  class="mt-4 mb-8   text-xl leading-10 font-extrabold tracking-wider text-red-500 "
                >
                  Permission has not been given for marketing
                </h1>
                <vue-markdown
                  :source="project.projectDescription"
                  class="text-gray-700 text-base prose"
                ></vue-markdown>

                <question-answer
                  question="What was your inspiration?"
                  :answer="project.inspiration"
                  class="mt-10"
                ></question-answer>
                <question-answer
                  question="What materials were used?"
                  :answer="project.materialsUsed"
                  class="mt-10"
                ></question-answer>
                <question-answer
                  question="What size is your project"
                  :answer="project.projectSize"
                  class="mt-10"
                ></question-answer>
                <question-answer
                  question="What tools & finishes were used?"
                  :answer="project.finishes"
                  class="mt-10"
                ></question-answer>
                <question-answer
                  question="If you did it again, what would you do differently?"
                  :answer="project.hindsight"
                  class="mt-10"
                ></question-answer>
                <simple-gallery
                  :images="project.projectPhotos"
                  v-if="hasVideo"
                ></simple-gallery>
              </div>

              <!--              second column -->
              <div class="text-gray-500">
                <h3 class="text-purple text-2xl tracking-wide font-bebas">
                  Comments
                </h3>
                <div class="mt-2">
                  <project-comment-area
                    :document-id="project._id"
                  ></project-comment-area>
                </div>
              </div>
            </div>

            <div class="mt-6"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sanityClient } from "../utils/sanity";
import VueMarkdown from "vue-markdown";
import ProjectCommentArea from "../components/ProjectCommentArea";
import ReactionBar from "../components/ReactionBar";
import {
  VueFlux,
  FluxControls,
  FluxIndex,
  FluxPagination,
  FluxPreloader
} from "vue-flux";
import QuestionAnswer from "../components/QuestionAnswer";
import SimpleGallery from "../components/SimpleGallery";
import { mapGetters } from "vuex";

export default {
  name: "Project",
  components: {
    SimpleGallery,
    VueMarkdown,
    QuestionAnswer,
    ProjectCommentArea,
    ReactionBar,
    VueFlux,
    FluxControls,
    FluxIndex,
    FluxPagination,
    FluxPreloader
  },
  data() {
    return {
      vfOptions: {
        autoplay: false,
        allowFullscreen: true
      },
      vfTransitions: [
        {
          name: "slide",
          options: {
            totalDuration: 1400,
            easing: "ease-in-out"
          }
        }
      ],
      project: null
    };
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    hasVideo() {
      return (
        this.project.youtube !== null &&
        this.project.youtube !== undefined &&
        this.project.youtube.length > 0
      );
    },
    youtubeUrl() {
      return "https://youtube.com/embed/" + this.project.youtube;
    }
  },
  created() {
    const id = this.$route.params.id;
    const queryString = "*[_type == 'userProject' && _id == $id][0]{...}";
    sanityClient
      .fetch(queryString, { id })
      .then(res => {
        this.project = res;
      })
      .catch(function(err) {
        console.log(err);
      });
  }
};
</script>
